import {useMutation, useQueryClient} from "@tanstack/react-query";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {toast} from "react-toastify";
import {IFolderCreate} from "../../types/knowledgeBase.types";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";

export function useCreateKBFolder() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.CREATE_FOLDER],
        mutationFn: (createData: IFolderCreate) => KnowledgeBaseAPI.createFolder(createData),
        onError() {
            toast.error("Ошибка создания папки");
        },
        onSuccess: (_, variables) => {
            // Проверяем, есть ли родительская папка (создаем подпапку)
            if (variables.parentFolder) {
                // Инвалидируем запрос на получение файлов для родительской папки
                queryClient.invalidateQueries({
                    queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_FILES, variables.parentFolder]
                });
            } else {
                // Инвалидируем запрос на получение корневых папок
                queryClient.invalidateQueries({
                    queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDERS]
                });
            }
            toast.success("Новая папка создана");
        }
    });
}
